import { useColorPreset } from "@app/hooks/useColorPreset"
import { Flex, FlexProps, Text } from "@chakra-ui/react"

export type LowStockSettings = {
  settingLowStockMessageText: string | null | undefined
  settingLowStockMessageColour: GatsbyTypes.NewPresetColorFragmentFragment | null | undefined
}

type Props = {
  settings: LowStockSettings
  size?: string
} & FlexProps

export const LowStockMessage = ({
  settings: { settingLowStockMessageText, settingLowStockMessageColour },
  size = "md",
  ...props
}: Props) => {
  const { color: buttonColor } = useColorPreset(settingLowStockMessageColour)

  return (
    <Flex
      bg={buttonColor}
      px={2}
      borderRadius="8px"
      display="inline-flex"
      alignItems="center"
      w="fit-content"
      whiteSpace="nowrap"
      {...props}
    >
      <Text color="primary.midGrey" size={size}>
        {settingLowStockMessageText}
      </Text>
    </Flex>
  )
}
